export const ALL_MONTHS = [
  {
    name: "يناير",
    value: 1,
    translation: [{ name: "January", locale: "en" }],
  },
  {
    name: "فبراير",
    value: 2,
    translation: [{ name: "February", locale: "en" }],
  },
  {
    name: "مارس",
    value: 3,
    translation: [{ name: "March", locale: "en" }],
  },
  {
    name: "إبريل",
    value: 4,
    translation: [{ name: "April", locale: "en" }],
  },
  {
    name: "مايو",
    value: 5,
    translation: [{ name: "May", locale: "en" }],
  },
  {
    name: "يونيه",
    value: 6,
    translation: [{ name: "June", locale: "en" }],
  },
  {
    name: "يوليو",
    value: 7,
    translation: [{ name: "July", locale: "en" }],
  },
  {
    name: "اغسطس",
    value: 8,
    translation: [{ name: "August", locale: "en" }],
  },
  {
    name: "سبتمبر",
    value: 9,
    translation: [{ name: "September", locale: "en" }],
  },
  {
    name: "اكتوبر",
    value: 10,
    translation: [{ name: "October", locale: "en" }],
  },
  {
    name: "نوفمبر",
    value: 11,
    translation: [{ name: "November", locale: "en" }],
  },
  {
    name: "ديسمبر",
    value: 12,
    translation: [{ name: "December", locale: "en" }],
  },
];

export const ALL_QUARTERS = [
  {
    name: "الربع الأول",
    value: 1,
    translation: [{ name: "First Quarter", locale: "en" }],
  },
  {
    name: "الربع الثاني",
    value: 2,
    translation: [{ name: "Second Quarter", locale: "en" }],
  },
  {
    name: "الربع الثالث",
    value: 3,
    translation: [{ name: "Third Quarter", locale: "en" }],
  },
  {
    name: "الربع الرابع",
    value: 4,
    translation: [{ name: "Fourth Quarter", locale: "en" }],
  },
];

export const ALL_HALFS = [
  {
    name: "النصف الأول",
    value: 2,
    translation: [{ name: "First Half", locale: "en" }],
  },
  {
    name: "النصف الثاني",
    value: 4,
    translation: [{ name: "Second Half", locale: "en" }],
  },
];

export function getPeriodsList(periodsFetching) {
  if (
    periodsFetching.error ||
    periodsFetching.isLoading ||
    periodsFetching.data === undefined ||
    !periodsFetching.data.data
  ) {
    return [];
  }
  return periodsFetching.data.data;
}

export function getPeriodFieldIds(periods, year, field) {
  return periods
    .filter((item) => item.year === +year)
    .map((item) => item[field])
    .flat();
}

export function getUniqueYears(periods) {
  return [...new Set(periods.map((item) => item.year))];
}

export function filterPeriodOptions(allOptions, ids) {
  return allOptions.filter((item) => ids.includes(item.value));
}

export function mapSearchDetails(searchFetching) {
  const renderSearch =
    searchFetching.error ||
    searchFetching.isLoading ||
    searchFetching.data === undefined ||
    searchFetching.data === null ||
    !searchFetching.data.data
      ? {}
      : { ...searchFetching.data.data };

  const publicationDetailsFiles = renderSearch?.publicationDetailsFiles;

  return {
    excelUrl: renderSearch?.excelUrl,
    id: renderSearch?.id,
    month: renderSearch?.month,
    pdfUrl: renderSearch?.pdfUrl,
    publicationCover: renderSearch?.publicationCover,
    publishDate: renderSearch?.publishDate,
    quarter: renderSearch?.quarter,
    releaseDate: renderSearch?.releaseDate,
    studyPeriod: renderSearch?.studyPeriodAsString,
    year: renderSearch?.year,
    publicationDetailsFiles,
    pdfFiles: publicationDetailsFiles?.filter((el) => el.fileType === 2),
    excelFiles: publicationDetailsFiles?.filter((el) => el.fileType === 1),
  };
}

export function buildSearchUrl(baseUrl, id, { selectYear, selectMonth, selectQuarter, currentYearMonthIds, currentYearQuarterIds }) {
  let url = `${baseUrl}=${id}`;

  if (selectYear !== null && selectYear !== undefined) {
    url += `&Year=${selectYear}`;
  }

  if (
    selectMonth !== null &&
    selectMonth !== undefined &&
    selectMonth !== -1 &&
    currentYearMonthIds.length > 0
  ) {
    url += `&Month=${selectMonth}`;
  }

  if (
    selectQuarter !== null &&
    selectQuarter !== undefined &&
    selectQuarter !== -1 &&
    currentYearQuarterIds.length > 0
  ) {
    url += `&Quarter=${selectQuarter}`;
  }

  return url;
}
